import {ChangeDetectionStrategy,ChangeDetectorRef,Component,inject,signal} from '@angular/core';
import {PopupComponent} from '../../misc/components/popup/popup';
import {ServerError,ServerResponse} from '../../shared/server-message';
import {AuthenticationService} from '../authentication.service';
import {AppService} from '../../app.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormBuilder,FormControl,Validators} from '@angular/forms';
import {skip,take} from 'rxjs';
import {SnackMessageComponent} from '../../misc/components/snack-message/snack-message';
import {environment} from '../../../environments/environment';
import {PHONE_NUMBER_UTIL} from '../../common/phone-number/phone-number.tokens';
import {ConfirmationResult,RecaptchaVerifier,signInWithPhoneNumber} from 'firebase/auth';
import {FIREBASE_AUTH} from '../../common/firebase/firebase.tokens';
import {MATERIAL_IMPORTS} from '../../shared/material-imports';
import {COMMON_IMPORTS} from '../../shared/common-imports';
import {FormMessageComponent} from '../../misc/components/form-message/form-message';
import {InputEmptyToNullDirective} from '../../misc/directives/input-empty-to-null/input-empty-to-null.directive';

@Component({
	selector:'app-login-phone-popup',
	changeDetection:ChangeDetectionStrategy.OnPush,
	imports:[
		...MATERIAL_IMPORTS,
		...COMMON_IMPORTS,
		FormMessageComponent,
		InputEmptyToNullDirective
	],
	templateUrl:'./login-phone-popup.html',
	styleUrl:'./login-phone-popup.scss'
})
export class LoginPhonePopupComponent extends PopupComponent{
	protected readonly environment=environment;
	private changeDetectorRef=inject(ChangeDetectorRef);
	private authenticationService=inject(AuthenticationService);
	readonly phoneNumberUtil=inject(PHONE_NUMBER_UTIL);
	private appService=inject(AppService);
	private matSnackBar=inject(MatSnackBar);
	readonly auth=inject(FIREBASE_AUTH);
	private formBuilder=inject(FormBuilder);
	form=this.formBuilder.group({
		phoneCountryCode:new FormControl<string>('+57',{validators:[Validators.required]}),
		phone:new FormControl<string|null>(null,{validators:[Validators.required]})
	});
	serverError=signal<ServerError|null>(null);
	serverResponse=signal<ServerResponse|null>(null);
	submitButtonActive=signal<boolean>(true);
	recaptchaVerifier?:RecaptchaVerifier;
	phoneConfirmationResult=signal<ConfirmationResult|null>(null);
	
	
	sendOtp():void{
		if(this.submitButtonActive()){
			const {phoneCountryCode,phone}=this.form.getRawValue();
			const isNotValid=!phoneCountryCode || !phone;
			if(!this.form.valid || isNotValid){
				this.form.markAllAsTouched();
			}else{
				this.serverError.set(null);
				this.serverResponse.set(null);
				this.recaptchaVerifier=new RecaptchaVerifier(
					this.auth,
					'login-phone-recaptcha-container',
					{
						size:'normal',
						callback:()=>{
							signInWithPhoneNumber(this.auth,`${phoneCountryCode}${phone}`,this.recaptchaVerifier)
							.then((response)=>{
								this.phoneConfirmationResult.set(response);
								this.recaptchaVerifier?.clear();
								this.recaptchaVerifier=undefined;
							})
							.catch((error:ServerError)=>{
								this.serverError.set(error);
								this.recaptchaVerifier?.clear();
								this.recaptchaVerifier=undefined;
							});
						},
						'expired-callback':(error:ServerError)=>{
							this.serverError.set(error);
						},
						'error-callback':(error:ServerError)=>{
							this.serverError.set(error);
						}
					}
				);
				this.recaptchaVerifier.render()
				.catch((error:ServerError)=>{
					this.serverError.set(error);
				});
			}
		}
	}
	
	login(code:string):void{
		const phoneConfirmationResult=this.phoneConfirmationResult();
		if(this.submitButtonActive() && phoneConfirmationResult){
			this.serverError.set(null);
			this.serverResponse.set(null);
			phoneConfirmationResult.confirm(code)
			.then(async(result)=>{
				this.submitButtonActive.set(false);
				this.authenticationService.loginPhone({token:await result.user.getIdToken()})
				.subscribe({
					next:()=>{
						this.submitButtonActive.set(true);
						this.phoneConfirmationResult.set(null);
						this.authenticationService.totpPopup.set(true);
						this.authenticationService.userObservable
						.pipe(
							skip(1),
							take(1)
						)
						.subscribe((user)=>{
							if(user){
								this.matSnackBar.openFromComponent(SnackMessageComponent,{
									data:{
										response:$localize`:@@login-phone-popup-welcome|Phone login welcome snackbar:Bienvenido/a ${user?.firstName || ''}`
									},
									duration:2000
								});
								this.appService.getCart({}).subscribe();
							}else{
								this.matSnackBar.openFromComponent(SnackMessageComponent,{data:{error:'user not loaded'}});
							}
						});
						this.authenticationService.reloadUser();
						if(this.router.url==='/login'){
							this.close(false,'/profile');
						}else{
							this.close();
						}
					},
					error:(error:ServerError)=>{
						this.submitButtonActive.set(true);
						this.phoneConfirmationResult.set(null);
						this.serverError.set(error);
					}
				});
			})
			.catch((error:ServerError)=>{
				this.serverError.set(error);
			});
		}
	}
}
